const _ = 0.4, A = 1, E = 0.85, T = 0.1, O = 2, I = "ROADMAP", P = 16, o = 5e-4, t = 24, M = 300, c = 3e3, n = 500, s = 500, N = 300, U = 1e3;
export {
  I as DEFAULT_MAP_TYPE,
  E as DEFAULT_OVERLAY_OPACITY,
  P as DEFAULT_ZOOM,
  o as INITIAL_BOUNDS_OFFSET,
  t as MAP_CONTROL_SIZE,
  M as MAP_DRAG_TIMEOUT,
  N as MAP_PINS_UPDATE_DEBOUNCE,
  U as MAP_TYPE_CHANGE_DEBOUNCE,
  O as MAX_FILE_SIZE_MB,
  A as MAX_OVERLAY_OPACITY,
  _ as MIN_OVERLAY_OPACITY,
  T as OPACITY_STEP,
  n as OVERLAY_MANIPULATION_TIMEOUT,
  s as TRANSFORM_UPDATE_DEBOUNCE,
  c as USER_INTERACTION_TIMEOUT
};
